import React, { forwardRef } from 'react';
const Card = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({
  className = '',
  ...props
}, ref) => <div ref={ref} className={`rounded-lg border bg-card text-card-foreground shadow-sm ${className}`} {...props} data-id="element-137" />);
Card.displayName = 'Card';
const CardHeader = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({
  className = '',
  ...props
}, ref) => <div ref={ref} className={`flex flex-col space-y-1.5 p-6 ${className}`} {...props} data-id="element-138" />);
CardHeader.displayName = 'CardHeader';
const CardTitle = forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(({
  className = '',
  ...props
}, ref) => <h3 ref={ref} className={`text-2xl font-semibold leading-none tracking-tight ${className}`} {...props} data-id="element-139" />);
CardTitle.displayName = 'CardTitle';
const CardDescription = forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(({
  className = '',
  ...props
}, ref) => <p ref={ref} className={`text-sm text-muted-foreground ${className}`} {...props} data-id="element-140" />);
CardDescription.displayName = 'CardDescription';
const CardContent = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({
  className = '',
  ...props
}, ref) => <div ref={ref} className={`p-6 pt-0 ${className}`} {...props} data-id="element-141" />);
CardContent.displayName = 'CardContent';
const CardFooter = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({
  className = '',
  ...props
}, ref) => <div ref={ref} className={`flex items-center p-6 pt-0 ${className}`} {...props} data-id="element-142" />);
CardFooter.displayName = 'CardFooter';
export { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter };